module.exports = __webpack_public_path__ + "static/media/lms_logo_icon_primary_icon.993f5bc8.png";